import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

import ProductCard from "./ProductCard";
import "./Slider.css";

const ProductSlider = ({ products, singleSlide = false }) => {
  const validProducts = Array.isArray(products) ? products.filter(Boolean) : [];
  const productCount = validProducts.length;

  // Adjust settings based on product count and singleSlide prop
  let slidesToShow = singleSlide ? 1 : Math.min(productCount, 4); // If singleSlide is true, always show 1, otherwise show up to 4
  let slidesToScroll = singleSlide ? 1 : Math.min(productCount, 4);

  // Ensure that there is at least one card visible on larger screens, even if there are few products
  // If singleSlide is true, use simpler responsive settings that always show 1
  const responsiveSettings = singleSlide
    ? [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ]
    : [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: Math.max(productCount < 3 ? productCount : 3, 2), // At least 2 cards
            slidesToScroll: Math.max(productCount < 3 ? productCount : 3, 2),
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: Math.max(productCount < 2 ? productCount : 2, 1), // At least 1 card
            slidesToScroll: Math.max(productCount < 2 ? productCount : 2, 1),
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ];

  let settings = {
    dots: singleSlide ? productCount > 1 : productCount > 1, // Only show dots if more than 1 product
    infinite: singleSlide ? productCount > 1 : productCount > 1, // Only infinite if more than 1 product
    slidesToShow,
    slidesToScroll,
    initialSlide: 0,
    autoplay: singleSlide ? productCount > 1 : productCount > 1, // Only autoplay if more than 1 product
    autoplaySpeed: 5000,
    adaptiveHeight: true,
    responsive: responsiveSettings,
    arrows: productCount > 1, // Only show arrows if more than 1 product
  };

  return (
    <div className="slider-container-2">
      {productCount > 0 ? (
        <Slider {...settings}>
          {validProducts.map((product, index) => (
            <ProductCard key={product._id || index} data={product} />
          ))}
        </Slider>
      ) : (
        <div style={{ textAlign: "center", padding: "20px" }}>
          <p>Inga produkter att visa just nu.</p>
        </div>
      )}
    </div>
  );
};

export default ProductSlider;
